<template>
  <v-card class="mb-4"
          :class="{ 'kpi-clickable': clickable, 'kpi-active': active }"
          rounded="lg"
          @click="handleClick">
    <v-card-title class="d-flex align-center">
      <span class="text-body-2">{{ label }}</span>
      <v-tooltip v-if="tooltip" :text="tooltip" location="top">
        <template v-slot:activator="{ props }">
          <v-icon v-bind="props" icon="mdi-information" size="x-small" class="ml-2 opacity-60"></v-icon>
        </template>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-icon v-if="active" size="small" color="primary">mdi-filter</v-icon>
    </v-card-title>
    <v-card-text class="text-h4 pb-4" :style="valueStyle">
      {{ display }}
    </v-card-text>
  </v-card>
</template>

<script setup>
import { computed } from 'vue';

// KPI tile. Optionally acts as a filter toggle (the inspection tab's due
// buckets), in which case the parent owns the selection state.
const props = defineProps({
  label: { type: String, required: true },
  value: { type: [Number, String], default: 0 },
  formatter: { type: Function, default: null },
  tooltip: { type: String, default: '' },
  color: { type: String, default: '' },
  clickable: { type: Boolean, default: false },
  active: { type: Boolean, default: false },
});

const emit = defineEmits(['select']);

const display = computed(() => (props.formatter ? props.formatter(props.value) : props.value));
const valueStyle = computed(() => (props.color ? { color: props.color } : null));

const handleClick = () => {
  if (props.clickable) emit('select');
};
</script>

<style scoped>
.kpi-clickable {
  cursor: pointer;
}

.kpi-active {
  outline: 2px solid rgb(var(--v-theme-primary));
}
</style>
